import React, { useState, useEffect } from 'react'
import { Popconfirm } from 'antd'
import {
  Div, Input,
} from 'konsys-ui'
import {
  ButtonAction, LabelCell, DivCell,
  Table, DivRowSize, DivToolbar, DivTitle,
  DivItemCell, Label, DivActionColumn,
  ButtonActionNew, InputNumber,
} from './styled'
import { theme } from '../../../../../styles/_variables'

const { color } = theme

const EditableCell = ({
  editing,
  children,
  inputType,
  record,
  dataIndex,
  title,
  onChangeCell,
  onAddCellPrice,
  onRemoveCellPrice,
  alignCell = 'left',
  style,
  ...restProps
}) => {
  const [value, setValue] = useState(record ? record[dataIndex] : '')
  useEffect(() => {
    if (record && record[dataIndex]) {
      setValue(record[dataIndex])
    }
  }, [record])

  let inputNode = <DivItemCell>
    <InputNumber
      type="number"
      min={0}
      max={9999}
      value={value}
      width="100px"
      onChange={(e) => {
        if ((e === '' || parseFloat(e, 10) >= 0)) {
          setValue(e)
          onChangeCell(e, dataIndex)
        }
      }}
      onKeyPress={(e) => {
        if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
          e.preventDefault()
        }
      }}
    />
  </DivItemCell>
  let cellNode = <LabelCell>{children}</LabelCell>
  if (dataIndex === 'size') {
    inputNode = (<Div>
      {value.map((item, index) => (
        <DivRowSize key={index}>
          <DivItemCell>
            <InputNumber
              type="number"
              width="60px"
              min={0}
              max={9999}
              value={item.width}
              onChange={(e) => {
                if ((e === '' || parseFloat(e, 10) >= 0)) {
                  const tmpValue = [...value]
                  tmpValue[index].width = e
                  setValue(tmpValue)
                  onChangeCell(tmpValue, dataIndex)
                }
              }}
              onKeyPress={(e) => {
                if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                  e.preventDefault()
                }
              }}
            />
          </DivItemCell>
          <DivItemCell>
          X
          </DivItemCell>
          <DivItemCell>
          <InputNumber
            type="number"
            width="60px"
            value={item.height}
            min={0}
            max={9999}
            onChange={(e) => {
              if ((e === '' || parseFloat(e, 10) >= 0)) {
                const tmpValue = [...value]
                tmpValue[index].height = e
                setValue(tmpValue)
                onChangeCell(tmpValue, dataIndex)
              }
            }}
            onKeyPress={(e) => {
              if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault()
              }
            }}
          />
          </DivItemCell>
        </DivRowSize>
      ))}
    </Div>)
    cellNode = (<Div>
      {value.map(item => (<LabelCell key={item.key}>{item.width} X {item.height}</LabelCell>))}
    </Div>)
  }
  return (
    <td {...restProps}>
      <DivCell alignCell={alignCell}>
        {editing ? inputNode : cellNode}
      </DivCell>
    </td>
  )
}

const DieCutBlocksTable = ({
  pagination = false,
  data = [],
  onSubmitEditRow,
  title,
  onAddRow,
  onSubmitDeleteRow,
}) => {
  const [columns, setColumns] = useState([{
    title: 'ขนาดแม่พิมพ์ใบมีด (นิ้ว)',
    dataIndex: 'size',
    key: 'size',
    align: 'center',
    alignCell: 'center',
    editable: true,
  }, {
    title: 'ราคา (บาท/ตร.นิ้ว)',
    dataIndex: 'price',
    key: 'price',
    align: 'center',
    alignCell: 'center',
    editable: true,
  }])
  const [rows, setRows] = useState(data)
  const [editingKey, setEditingKey] = useState('')
  const [dataRowEditing, setDataRowEditing] = useState({})

  useEffect(() => {
    setRows(data)
  }, [data])

  const isEditingRow = record => record.key === editingKey

  const renderColumn = () => {
    let tmp = [...columns]
    tmp = columns.map((column) => {
      let onCell = {
        onCell: record => ({
          record,
          dataIndex: column.dataIndex,
          alignCell: column.alignCell,
          title: column.title,
        }),
      }
      if (column.editable) {
        onCell = {
          onCell: record => ({
            record,
            dataIndex: column.dataIndex,
            alignCell: column.alignCell,
            title: column.title,
            editing: isEditingRow(record),
            onChangeCell: (value, dataIndex) => {
              setDataRowEditing({
                ...dataRowEditing,
                [dataIndex]: value,
              })
            },
            onRemoveCellPrice: (indexRemove) => {
              const tmpRow = { ...dataRowEditing }
              tmpRow.size.splice(indexRemove, 1).map((item, indexItem) => ({ ...item, key: indexItem }))
              tmpRow.price.splice(indexRemove, 1)
              setDataRowEditing({
                ...tmpRow,
              })
            },
            onAddCellPrice: () => {
              const tmpRow = { ...dataRowEditing }
              tmpRow.size.push({ width: 0, height: 0, key: tmpRow.size.length })
              tmpRow.price.push(0)
              setDataRowEditing({
                ...tmpRow,
              })
            },
          }),
        }
      }
      return {
        title: column.title,
        dataIndex: column.dataIndex,
        key: column.key,
        align: 'center',
        // width: '10%',
        ...onCell,
      }
    })
    tmp.push({
      title: 'คำสั่ง',
      dataIndex: 'action',
      key: 'action',
      width: '120px',
      align: 'center',
      onCell: () => ({
        alignCell: 'center',
      }),
      render: (text, record) => {
        const editable = isEditingRow(record)
        return editable ? (
          <Div>
            <Div>
              <ButtonAction
                text='ยืนยัน'
                inverse
                icon='fa fa-floppy-o'
                onClick={() => {
                  const result = [...rows]
                  result[record.key] = { ...dataRowEditing }
                  setRows(result)
                  onSubmitEditRow(record.key, dataRowEditing)
                  setDataRowEditing({})
                  setEditingKey('')
                }}
              />
            </Div>
            <Div>
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => {
                  let result = JSON.parse(JSON.stringify([...rows]))
                  result.splice(record.key, 1)
                  result = result.map((item, index) => ({ ...item, key: index }))
                  setRows(result)
                  onSubmitDeleteRow(result)
                  setDataRowEditing({})
                  setEditingKey('')
                }}
              >
                <ButtonAction
                  text='ลบ'
                  icon='fa fa-trash-o'
                  color={color.error}
                />
              </Popconfirm>
            </Div>
          </Div>
        ) : (
          <ButtonAction
            disabled={editingKey !== ''}
            text='แก้ไข'
            inverse
            icon='fa fa-pencil-square-o'
            onClick={() => {
              setDataRowEditing(record)
              setEditingKey(record.key)
            }}
          />
        )
      },
    })
    return tmp
  }

  return (
    <Div>
      <DivToolbar>
        <DivTitle>
          <Label>{title}</Label>
        </DivTitle>
        <DivActionColumn>
          <ButtonActionNew
            text='New'
            disabled={editingKey !== ''}
            icon='fal fa-plus'
            inverse
            onClick={() => {
              const tmpRows = [...rows]
              const newRow = {
                key: tmpRows.length,
                price: [0],
                size: [{ width: 0, height: 0 }],
                dieCutBlockId: null,
              }
              tmpRows.push(newRow)
              onAddRow(tmpRows)
              setRows(tmpRows)
              setDataRowEditing(newRow)
              setEditingKey(newRow.key)
            }}
          />
        </DivActionColumn>
      </DivToolbar>
      <Div>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          pagination={pagination}
          columns={renderColumn()}
          dataSource={rows}
        />
      </Div>
    </Div>
  )
}

export default DieCutBlocksTable
